import React from 'react'
import Link from 'gatsby-link'

const Footer = props => (
  <footer id="footer">
    <div className="inner">
      <ul className="icons">
        <li>
          <a
            href="https://twitter.com/idealkraft"
            className="icon alt fa-twitter"
          >
            <span className="label">Twitter</span>
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/idealkraft/"
            className="icon alt fa-facebook"
          >
            <span className="label">Facebook</span>
          </a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/idealkraft/"
            className="icon alt fa-instagram"
          >
            <span className="label">Instagram</span>
          </a>
        </li>
      </ul>
      <ul className="copyright">
        <li>&copy; 2018 idealkraft.de</li>
        <li>
          Design: <a href="https://html5up.net">HTML5 UP</a>
        </li>
        <li>
          <Link to="/datenschutz">Datenschutzerklärung</Link>
        </li>
        <li>
          <Link to="impressum">Impressum</Link>
        </li>
      </ul>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js